import { doc, updateDoc } from 'firebase/firestore';
import React, { useCallback, useEffect, useState } from 'react';
import { useAuth } from '~/hooks/auth';
import { useOrders } from '~/hooks/orders';
import { useToast } from '~/hooks/toast';
import IOrder from '~/interfaces/IOrder';
import {
  InputContainer,
  SelectContainer,
} from '~/pages/POS/components/OrderConfirm/styles';
import { bff } from '~/services/bff';
import { DB } from '~/services/firebase';
import getCurrencyFormatted from '~/utils/getCurrencyFormatted';

type ChangePaymentMethodProps = {
  order: IOrder;
  onClose: () => void;
  show: boolean;
};

type OrderPayment = {
  payment_method_id: string;
  value: number;
  value2?: number;
  value_formatted: string;
};

const { REACT_APP_FIREBASE_PROJECT } = process.env;

export const ChangePaymentMethod: React.FC<ChangePaymentMethodProps> = ({
  show,
  onClose,
  order,
}) => {
  const [orderPayments, setOrderPayments] = useState<OrderPayment[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({} as any);
  const { company } = useAuth();
  const { addToast } = useToast();
  const { updateOrderList } = useOrders();

  const removeOrderPayment = useCallback(
    (index: number) => {
      const tmp = [...orderPayments];
      tmp.splice(index, 1);
      setOrderPayments(tmp);
    },
    [orderPayments],
  );

  const addNewPaymentMethod = useCallback(() => {
    let sum = 0;

    orderPayments.forEach(item => {
      sum += item.value;
    });

    const remaining = order.total - sum;

    setOrderPayments(value => [
      ...value,
      {
        payment_method_id: '',
        value: remaining,
        value_formatted: getCurrencyFormatted(remaining),
      },
    ]);

    setTimeout(() => {
      ($('.money') as any).mask('#.##0,00', { reverse: true });
    }, 100);
  }, [orderPayments, order.total]);

  useEffect(() => {
    if (order.total > 0) {
      setOrderPayments([
        {
          payment_method_id: '',
          value: order.total,
          value_formatted: getCurrencyFormatted(order.total),
        },
      ]);
    }
  }, [order.total]);

  useEffect(() => {
    ($('.money') as any).mask('#.##0,00', { reverse: true });
  }, [orderPayments]);

  const handleSubmit = useCallback(async () => {
    try {
      let hasPaymentMethod = true;
      orderPayments.forEach(item => {
        if (!item.payment_method_id) hasPaymentMethod = false;
      });

      if (!hasPaymentMethod) {
        setError({
          paymentMethod: true,
        });
        return;
      }

      setLoading(true);

      await updateDoc(doc(DB, 'orders', String(order.uid)), {
        paymentMethod: '',
        orderPayments: orderPayments.map(item => ({
          ...item,
          value: item.value2 ? item.value2 : item.value,
        })),
      });

      await bff.delete(`orders/${REACT_APP_FIREBASE_PROJECT}`);

      updateOrderList(String(order.uid), {
        ...order,
        paymentMethod: '',
        orderPayments: orderPayments.map(item => ({
          ...item,
          value: item.value2 ? item.value2 : item.value,
        })),
      });

      onClose();

      addToast({
        type: 'success',
        description: 'A forma de pagamento do pedido foi alterado com sucesso!',
      });
    } catch (error) {
      console.log(error);
      addToast({
        type: 'danger',
        description: 'Não foi possícel atualizar a forma de pagamento!',
      });
    }
  }, [orderPayments, order, addToast, updateOrderList, onClose]);

  return (
    <div className="news-modal" style={{ display: show ? 'block' : 'none' }}>
      <div
        className="modal fade"
        tabIndex={-1}
        id="modalDefault"
        style={{ display: 'block', opacity: 1 }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Alterar Forma de Pagamento</h5>
              <div role="button" className="close" onClick={onClose}>
                <em className="icon ni ni-cross" />
              </div>
            </div>
            <div className="modal-body">
              <div className="d-flex justify-content-between">
                <h5>TOTAL</h5>
                <h5>{getCurrencyFormatted(order.total)}</h5>
              </div>
              {/* {addCardValue > 0 && (
                <div className="d-flex justify-content-between">
                  <h5 className="text-danger">Acréscimo Cartão</h5>
                  <h5 className="text-danger">
                    {getCurrencyFormatted(addCardValue)}
                  </h5>
                </div>
              )} */}
              <h6 className="mt-4">Informe a forma de pagamento</h6>
              <div className="d-flex">
                <div className="w-100">Valor</div>
                <div className="w-100">Forma de pagamento</div>
                <div style={{ width: 80 }} />
              </div>
              {orderPayments.map((paymentItem, index) => (
                <div className="d-flex align-items-start">
                  <div className="w-100">
                    <InputContainer>
                      <input
                        id={`payment-value-${index}`}
                        type="text"
                        className="money"
                        placeholder="R$ 0,00"
                        defaultValue={paymentItem.value_formatted}
                        onKeyUp={() => {
                          const { value } = document.getElementById(
                            `payment-value-${index}`,
                          ) as any;

                          let parseValue = '0';

                          if (value) {
                            parseValue = value.replaceAll('.', '');
                            parseValue = parseValue.replaceAll(',', '.');
                          }

                          const tmp = [...orderPayments];
                          tmp[index].value = parseFloat(parseValue);
                          tmp[index].value_formatted = getCurrencyFormatted(
                            parseFloat(parseValue),
                          );

                          setOrderPayments(tmp);
                        }}
                      />
                    </InputContainer>
                  </div>
                  <div className="w-100 ml-2 mr-2">
                    <SelectContainer className="w-100">
                      <select
                        id="payment"
                        defaultValue={orderPayments[index].payment_method_id}
                        onChange={event => {
                          const paymentType = event.target.value;

                          const { value } = document.getElementById(
                            `payment-value-${index}`,
                          ) as any;

                          let parseValue = '0';

                          if (value) {
                            parseValue = value.replaceAll('.', '');
                            parseValue = parseValue.replaceAll(',', '.');
                          }

                          const valueRef = parseFloat(parseValue);

                          const tmp = [...orderPayments];
                          tmp[index].payment_method_id = event.target.value;

                          tmp[index].value2 = valueRef;

                          tmp[index].value_formatted =
                            getCurrencyFormatted(valueRef);

                          setOrderPayments(tmp);
                        }}
                      >
                        <option value="">Selecione...</option>
                        <option value="0">Dinheiro</option>
                        <option value="1">Débito</option>
                        <option value="2">Crédito</option>
                        <option value="3">PIX</option>
                        {company.sell_on_credit === '1' && (
                          <option value="4">Fiado</option>
                        )}
                        <option value="5">IFood</option>
                      </select>
                    </SelectContainer>
                  </div>

                  {index === 0 && (
                    <button
                      type="button"
                      onClick={addNewPaymentMethod}
                      style={{ width: 80, height: 40 }}
                    >
                      <em className="icon ni ni-plus" />
                    </button>
                  )}

                  {index > 0 && (
                    <button
                      type="button"
                      onClick={() => removeOrderPayment(index)}
                      style={{ width: 80, height: 40 }}
                    >
                      <em className="icon ni ni-trash" />
                    </button>
                  )}
                </div>
              ))}

              {error.paymentMethod && (
                <p className="text-danger" style={{ fontSize: 12 }}>
                  * Por favor, selecione a forma de pagamento.
                </p>
              )}

              <button
                type="button"
                onClick={handleSubmit}
                className="btn btn-primary mt-3 w-100 d-flex justify-content-center items-align-center p-2"
              >
                {loading && (
                  <div className="d-flex justify-content-center">
                    <div
                      className="spinner-border"
                      role="status"
                      style={{ width: 22, height: 22 }}
                    >
                      <span className="visually-hidden" />
                    </div>
                  </div>
                )}
                {!loading && `Salvar`}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
